export default __webpack_public_path__ + "static/media/tdex-color-mini.da2fb6cd.svg";